import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportTaskBurnUp_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportTaskBurnUp extends Report<ReportTaskBurnUp_Settings> {

    static reportName   : string = "Burnup"

    declare settings     : ReportTaskBurnUp_Settings

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_TASK_BURN_UP
        super(data);

        this.icon         = "isvg-burnup"
        // this.description  = "The Burnup Report tracks completed work against the total scope, helping determine if a project is progressing as expected and on track to meet deadlines."
        // this.description  = "Shows progress toward project goals by tracking completed tasks and remaining work over time, helping to visualize progress and identify potential delays or scope changes."
        this.description  = "Shows progress toward goals by tracking completed tasks and remaining work, visualizing progress and identifying delays or changes."

        this.settings     = new ReportTaskBurnUp_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportTaskBurnUp {
        return new ReportTaskBurnUp(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportTaskBurnUp_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)
        this.settings.projectId = projectId
    }

    save(){
        console.log("Not implemented")
    }
}
